<template>
  <div class="bg_wrap" aria-hidden="true">
    <div id="particles-js"></div>
  </div>
</template>

<script>
import config from "@/assets/particlesjs-config.json";

export default {
  name: "LandingBackground",
  mounted() {
    if (window.particlesJS) {
      window.particlesJS("particles-js", config);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_mixin.scss";

.bg_wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
